import { render, staticRenderFns } from "./Multitag.vue?vue&type=template&id=5d284040&scoped=true&"
import script from "./Multitag.vue?vue&type=script&lang=js&"
export * from "./Multitag.vue?vue&type=script&lang=js&"
import style0 from "./Multitag.vue?vue&type=style&index=0&id=5d284040&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d284040",
  null
  
)

export default component.exports